import {Box} from '@mui/material'
import {ReactNode} from 'react'
import {NavBar} from './NavBar'
import { SelectedYearProvider } from '../../modules/common/pages/SelectedYearContext'

interface Props {
  children?: ReactNode
}

export const AppLayout = ({children}: Props) => {
  return (
    <SelectedYearProvider>
    <Box
      sx={(theme) => ({
        px: 8,
        py: 5,
        [theme.breakpoints.down('lg')]: {
          px: 5,
          py: 3,
        },
        [theme.breakpoints.down('sm')]: {
          px: 1,
          py: 1,
        },
      })}
    >
      <Box
        component={NavBar}
        sx={(theme) => ({
          mb: 8,
          [theme.breakpoints.down('lg')]: {
            mb: 5,
          },
          [theme.breakpoints.down('sm')]: {
            mb: 1,
          },
        })}
      />
      {children}
    </Box>
    </ SelectedYearProvider>
  )
}
